module.exports = __webpack_public_path__ + "static/media/logo-ana.0c34ebff.webp";